import { t } from 'i18next';

const embargoErrorMessageUpdated = (error) => {
  let isEmbargoErrorMessageUpdated = false;
  let embargoPostalcode;
  if (error.response && error.response.data) {
    let messageContent;

    const regexCurlyBrackets = /\{([^}]+)\}/g; // Matches any text between { and }
    const matchesCurlyBrackets = error.response.data.match(regexCurlyBrackets);

    if (matchesCurlyBrackets && matchesCurlyBrackets.length > 0) {
      const curlyBracketsMatch = matchesCurlyBrackets[0];
      const innerText = `${curlyBracketsMatch}}`;
      if (innerText) {
        const json = JSON.parse(innerText);
        if (json && json.GetRateResponse && json.GetRateResponse.message) {
          messageContent = json.GetRateResponse.message;
        }
      }
    }

    isEmbargoErrorMessageUpdated = (messageContent || '').includes('endZone') || (messageContent || '').includes('startZone');

    if (isEmbargoErrorMessageUpdated) {
      const regexParentheses = /\(([^)]+)\)/g; // Matches any text between ( and )
      const matchesParentheses = messageContent.match(regexParentheses);

      if (matchesParentheses && matchesParentheses.length > 0) {
        const parenthesesMatch = matchesParentheses[0];
        embargoPostalcode = parenthesesMatch.substring(1, parenthesesMatch.length - 1);
      }
    }
  }

  const errorMessage = isEmbargoErrorMessageUpdated ? t('EmbargoErrorMessageUpdated', { postalcode: embargoPostalcode }) : t('ErrorMessage');

  return { errorMessage, isEmbargoErrorMessageUpdated };
};

export default embargoErrorMessageUpdated;
